import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Mail, Lock, LogIn, ShieldCheck, ChevronRight } from 'lucide-react';
import './LoginPage.css';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Échec de la connexion. Vérifiez vos identifiants.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-side-decoration">
        <div className="deco-content">
          <div className="deco-text">
            <h2 className="deco-title">Gestion de Stocks & Formations</h2>
            <p className="deco-subtitle">Optimisez vos ressources industrielles avec précision et efficacité.</p>
          </div>
          <div className="deco-features">
            <div className="feature-item"><ShieldCheck size={18} /> Accès hautement sécurisé</div>
            <div className="feature-item"><ChevronRight size={18} /> Pilotage global en temps réel</div>
          </div>
        </div>
        <div className="deco-overlay"></div>
      </div>

      <div className="login-side-form">
        <div className="login-card-refined">
          <div className="form-header">
            <img src="/logo.png" alt="PMS (Procurement Management System)" className="form-logo" />
            <h1 className="form-title">Bienvenue</h1>
            <p className="form-subtitle">Connectez-vous à votre interface PMS</p>
          </div>

          {error && (
            <div className="error-alert">
              <span className="error-icon">!</span>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="refined-form">
            <div className="input-field">
              <label>Identifiant Email</label>
              <div className="input-container">
                <Mail size={18} className="field-icon" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="nom@wwsenergies.fr"
                  autoComplete="email"
                />
              </div>
            </div>

            <div className="input-field">
              <label>Mot de passe</label>
              <div className="input-container">
                <Lock size={18} className="field-icon" />
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  placeholder="••••••••"
                  autoComplete="current-password"
                />
              </div>
            </div>

            <button type="submit" className="refined-submit-btn" disabled={loading}>
              {loading ? (
                <div className="button-loader"></div>
              ) : (
                <>
                  Accéder à la plateforme <LogIn size={18} />
                </>
              )}
            </button>

            <div className="login-forgot">
              <Link to="/forgot-password" className="login-forgot-link">Mot de passe oublié ?</Link>
            </div>
          </form>

          <div className="demo-hint-refined">
            <p>Accès Démo : <span>responsable@demo.fr</span> / <span>demo123</span></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;


